import { createAgencyApp } from '@/createApp';
import { createHead } from '@unhead/vue/client';
import { createApp } from 'vue';
import type { LocaleMessages } from 'vue-i18n';
import App from './AppIs24.vue';
import { createAuth0Instance } from './helpers/Auth/authClient';
import { initDatadogRUM } from './helpers/Datadog/DatadogRUMService';
import translationsIS24 from './i18n/de-is24';

(async () => {
  const app = createApp(App);

  const { router, pinia, store } = await createAgencyApp(
    app,
    translationsIS24 as unknown as LocaleMessages<never>,
    createHead,
  );

  initDatadogRUM();

  const initialState = window.__INITIAL_STATE__;
  if (initialState) {
    pinia.state.value = initialState;
  }

  const splitState = window.__SPLIT_STATE__;
  if (splitState) {
    store.replaceState(splitState);
  }

  const auth0 = createAuth0Instance();
  if (auth0) {
    app.use(auth0);
  }

  await router.isReady();
  app.mount('#app');
})();
